import React from 'react';
import { Grid, Typography } from '@mui/material';
import { IMealSectionProps } from 'app/models/Orders/OrderDetails';
import { useStyles } from './OrderDetailsReportStyles';
import { useTranslation } from 'react-i18next';

type MealSectionProps = {
  mealsDetails: IMealSectionProps;
};
export const OrderDetailsReportMealsInfo = (props: MealSectionProps) => {
  const { classes } = useStyles();
  const mealDetails = props.mealsDetails;
  const { t } = useTranslation();
  return (
    <Grid container>
      <Grid xs={6} md={2} className={`${classes.labelCell}`}>
        <Typography>{t('order.orderReportDetails.mealsSection.mealsandincidentals')}:</Typography>
      </Grid>
      <Grid xs={6} md={10} className={`${classes.dataCell}`}>
        {mealDetails.mealsAndIncidentals}
      </Grid>
    </Grid>
  );
};
